// import 'babel-polyfill';
// import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import validate from "jquery-validation";
import select2 from '../../node_modules/select2/dist/js/select2.full';
import Inputmask from "inputmask";
import Swiper from 'swiper'; 
// import gsap from "gsap";
// import 'tooltipster/dist/js/tooltipster.main.min';
// import 'tooltipster/dist/js/tooltipster.bundle.min';
// import Swiper, { Navigation, Pagination, Thumbs, Autoplay } from 'swiper';
// Swiper.use([Navigation, Pagination, Thumbs, Autoplay]);
import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui"; 
import ionRangeSlider  from "ion-rangeslider";
// import intlTelInput from 'intl-tel-input';
import datetimepicker from 'jquery-datetimepicker';

 
select2($);  
 
 
window.ionRangeSlider = ionRangeSlider; 

window.$ = $;
window.jQuery = $;
window.validate = validate;
window.select2 = select2;
window.Inputmask=window;
// window.intlTelInput = intlTelInput;
window.Swiper = Swiper;
// window.gsap= gsap;
window.$W = $(window);
window.$D = $(document); 
window.$H = $('html');
window.$B = $('body');
window.Fancybox= Fancybox; 
window.datetimepicker= datetimepicker; 
 
// svg4everybody();